<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M6.10002 3.56669L4.04169 3.09169L3.09169 4.04169L3.56669 6.10002L1.66669 7.36669V8.63335L3.56669 9.90002L3.09169 11.9584L4.04169 12.9084L6.10002 12.4334L7.36669 14.3334H8.63335L9.90002 12.4334L11.9584 12.9084L12.9084 11.9584L12.4334 9.90002L14.3334 8.63335V7.36669L12.4334 6.10002L12.9084 4.04169L11.9584 3.09169L9.90002 3.56669L8.63335 1.66669H7.36669L6.10002 3.56669Z"
    stroke="currentColor"
  />
  <path
    d="M10 8.00002C10 9.10459 9.10459 10 8.00002 10C6.89545 10 6.00002 9.10459 6.00002 8.00002C6.00002 6.89545 6.89545 6.00002 8.00002 6.00002C9.10459 6.00002 10 6.89545 10 8.00002Z"
    stroke="currentColor"
  />
</svg>
